<div class="fullcontainer">
  <div class='sheet'>
    @if (this.isError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    @if (this.isSuccess) {
      <div class="alert alert-success">Driver hours was updated successfully</div>
    }
    <div class='titleContainer'>
      <h1 class='header'>Daily Fuel for {{ this.currentDate }}</h1>
      <div>
        <button class='btn btn-secondary' routerLink='/fuel/prices'><i class="fas fa-money-bill-wave"></i> Manage Fuel Prices</button> &nbsp;
        <button class='btn btn-secondary' routerLink='/fuel/advanced'><i class="fas fa-cog"></i> Advanced</button>
      </div>
    </div>
  </div>
</div>
